<!-- 
Dialog for deleting a scheduled job.
-->
<template>
  <v-dialog :value="show" persistent content-class="dialog xs">
    <v-card>
      <v-toolbar color="secondary" flat dark>
        <v-toolbar-title>Delete scheduled job</v-toolbar-title>
      </v-toolbar>
      <our-busy-indicator :show="state.saving"/>
      <v-card-text>Are you sure you want to delete this scheduled job? This action cannot be undone.</v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn :disabled="state.saving" flat @click="hide">Cancel</v-btn>
        <v-btn :disabled="state.saving" flat color="error" @click="deleteScheduledJob">
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import * as action from "@/store/scheduled-jobs/action-types";
import * as mutation from "@/store/scheduled-jobs/mutation-types";

export default {
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    scheduledJobId: {
      type: Number,
      default: null
    }
  },
  computed: {
    state() {
      return this.$store.state.scheduledJobs.delete;
    }
  },
  watch: {
    async show(nowShowing) {
      if (nowShowing) {
        this.$store.commit(mutation.DELETE_INITIALISE);
      }
    }
  },
  methods: {
    async deleteScheduledJob() {
      const succeeded = await this.$store.dispatch(action.EDIT_DELETE, this.scheduledJobId);
      this.hide();
      if (succeeded) {
        this.$emit("changed");
      }
    },
    hide() {
      this.$emit("update:show", false);
    }
  }
};
</script>
